
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


export interface FundDDL {
    fundId: string;
    fundName: string;
}
 
export class UserContext {
    accessToken!: string
    tenentId!: string;
    email!: string;
    displayName!: string;
    firstName!: string;
    lastName!: string;
    usertype!: string;
    fundId!: string;
    FundName!: string;
    isExternal!: boolean;
    isAppraisal1!: boolean;
    isAppraisal2!: boolean;
    isAppraisal3!: boolean;
    isFiduciary!: boolean;
    isDebtAppraisal1!: boolean;
    isDebtAppraisal2!: boolean;
    isDebtAppraisal3!: boolean;
    isDebtFiduciary!: boolean;
    isAccounting!: boolean;
    isAudit!: boolean;
    isAssetManagement!: boolean;
    isAdmin!: boolean;
    appraiser1: any;
    appraiser2: any;
    appraiser3: any;
    fiduciary: any;
    debtAppraiser1: any;
    debtAppraiser2: any;
    debtAppraiser3: any;
    debtFiduciary: any;
    accounting: any;
    admin: any;
    audit: any;
    assetManagement: any;
    firm!: string;
    taskManagementToken: any;
    investmentToken: any;
    lookupToken: any;
    documentToken: any;
    appraisalToken: any;
    logginToken: any;
    isEMEA: any;
    isAPAC: any;
    isUS: any;
    region: any;
    allowedFunds!:FundDDL[];
}

interface InitialState {
    data: UserContext,
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: {} as UserContext,
    error: '',
    loading: false
}

const userContextSlice = createSlice({
    name: "uerContext",
    initialState,
    reducers: {
        updateUserContext(state, action: PayloadAction<UserContext>) {
            state.data = action.payload;
        },
    },
});

export const { updateUserContext } = userContextSlice.actions;

export default userContextSlice.reducer;